export const DocumentProductionStatus = {
  New: 0,
  Draft: 1,
  SentToProduction: 2,
  Finished: 3
}
